// import moment from 'moment';
import preserveUTMParams from '@/utils/preserveUTMParams';

export default {
	/*
	 * This handles all the login functionality and forces the user to login when en specific sale requiers this
	 *
	 * Sales options:
	 *
	 * Preregistration
	 * Membersale
	 * Travelsale
	 *
	 */

	data() {
		return {
			isShopInited: false,
			isCheckingPreregistrations: false
		};
	},

	computed: {
		isMemberSaleUsed() {
			return this.$store.getters['sso/getIsMemberSaleUsed'];
		},

		allowedToShop() {
			return !this.isMemberSaleUsed && this.userHasPreregistered;
		},

		prebuilderChoice() {
			return this.$store.getters.getPrebuilderChoice;
		},

		allowedToEnterBuilder() {
			const allowed = (this.data.noCookieNeeded || !!this.prebuilderChoice) && this.$route.query.token;

			if (!allowed) this.$store.commit('shopconfig/setShowOverview', false);

			return allowed;
		},

		shopConfig() {
			return this.$store.getters['shopconfig/getData'];
		},

		cart() {
			return this.$store.getters['shopconfig/getCart'];
		},

		hasUpgradeModule() {
			return this.$store.getters['shopconfig/getHasUpgradeModule'];
		},

		isOrderIdRequired() {
			return this.shopConfig && this.shopConfig.orderIdRequired;
		},

		isAccessIdRequired() {
			return this.shopConfig && this.shopConfig.accessIdRequired;
		},

		upgradeOrderId() {
			return this.$store.getters.getUpgradeOrderId;
		},

		accessId() {
			return this.$store.getters.getAccessId;
		}

		/* paylogicToken() {
			return this.$store.getters['shopconfig/getPaylogictoken'];
		} */
	},

	watch: {
		isUserLoggedIn(val) {
			// console.log('isUserLoggedIn');
			if (val) {
				this.shopEventRulesValidation();
			}
		},

		isPreregistrationChecked(val) {
			// console.log('isPreregistrationChecked');
			this.shopEventRulesValidation();
			if (val) {
				this.isCheckingPreregistrations = false;
			}
		},

		membershipStatus() {
			this.shopEventRulesValidation();
		}
	},

	methods: {
		shopEventRulesValidation() {
			if (this.isUserLoggedIn && !this.isPreregistrationChecked && !this.isCheckingPreregistrations) {
				if (this.shopConfig.preregistrationKey) {
					this.isCheckingPreregistrations = true;
					this.loadUserPreregistration();
					return;
				}
			}

			if (this.data.membersale || this.data.preregistration || this.data.travelsale) {
				if (!this.isUserLoggedIn) {
					/*
					 * User has no valid login
					 */
					if (this.isLoginChecked) {
						this.$fireErrorEventWithPromis(6004).then(response => {
							this.userLogin();
						});
					}
					return;
				}

				// if (!this.isPreregistrationChecked) {
				// 	this.loadUserPreregistration();
				// 	return;
				// }

				if ((this.data.membersale || this.data.travelsale) && !this.allowedToShop) {
					/*
					 * User has no valid preregistration
					 */
					if (this.isPreregistrationChecked && !this.userHasPreregistered) {
						this.$fireErrorEvent(3000);
						this.$router.push({ path: '/', query: this.$route.query });
					}

					/*
					 * User has used his preregistration
					 */
					if (this.isMemberSaleUsed) {
						this.$fireErrorEvent(3001);
						this.$router.push({ path: '/', query: this.$route.query });
					}

					return;
				}
				// Timeslots
				// if ((this.data.membersale || this.data.travelsale) && this.data.withshopslot) {
				// 	/*
				// 	 * Get server time
				// 	 */
				// 	this.$axios
				// 		.get(`${process.env.SHOP_API_BASE}/shop/time`)
				// 		.then(response => {
				// 			const gigyaTime = this.userData.data
				// 				.qdance_dq1_2020_prereg_allowedfromtime;
				// 			const serverTime = moment
				// 				.unix(response.data.data.time)
				// 				.add(2, 'minutes');
				// 			const timestamp = moment.unix(gigyaTime);
				// 			const allowed = serverTime.isAfter(timestamp);

				// 			sif (gigyaTime && !allowed) {
				// 				/*
				// 				 * User has invalid timeslot
				// 				 */
				// 				this.$fireErrorEvent(3003);
				// 				this.$router.push('/');
				// 				return;
				// 			}
				// 		})
				// 		.catch(error => {
				// 			this.$fireErrorEvent(1000);
				// 			this.$router.push('/');
				// 			return;
				// 		});
				// }
			}

			if (this.hasUpgradeModule && !(this.upgradeOrderId || this.$route.query.idt_oss_order_id)) {
				// No order id found in url
				this.$fireErrorEventWithPromis(4002);
				this.$router.push({ path: '/', query: this.$route.query });
				return;
			}

			if (this.isOrderIdRequired && !(this.upgradeOrderId || this.$route.query.idt_oss_order_id)) {
				// No order id found in url
				this.$fireErrorEventWithPromis(4005);
				this.$router.push({ path: '/', query: this.$route.query });
				return;
			}

			if (this.isAccessIdRequired && !(this.accessId || this.$route.query.access_id)) {
				// No access id found in url
				this.$fireErrorEventWithPromis(4006);
				this.$router.push({ path: '/', query: this.$route.query });
				return;
			}

			if (this.data.loginRequired || this.shopConfig.membershipRequired) {
				if (this.isLoginChecked) {
					if (!this.isUserLoggedIn) {
						/*
						 * User has no valid login. General required  login check. Could be for selling membership or anything else.
						 */
						this.$fireErrorEventWithPromis(6004).then(response => {
							this.userLogin();
						});
						return;
					} else {
						if (this.shopConfig.membershipRequired) {
							if (this.membershipStatus > 0) {
								if (this.membershipStatus < 20) {
									this.$fireErrorEventWithPromis(6005).then(response => {
										window.location.replace(preserveUTMParams('https://shop.q-dance.com/network'));
										// window.location.replace('https://travel.q-dance.com/en/2021/qlimax-gelredome/');
									});
									return;
								}
							} else {
								// membershipStatus isn't loaded yet
								return;
							}
						}
					}
				} else {
					// Login not checked yet. Watcher will try this function again later
					return;
				}
			}

			this.authRequirements = true;
			/*
			 * The route must contain a token to proceed with prefilling
			 */
			// this.$route.query.token && this.updateCookieWithWishList();
			if (!this.isShopInited) {
				this.isShopInited = true;
				this.initShop();
			}
		}
	},

	mounted() {
		this.$route.query.idt_oss_order_id &&
			this.$store.commit('setUpgradeOrderId', this.$route.query.idt_oss_order_id);

		this.$route.query.access_id && this.$store.commit('setAccessId', this.$route.query.access_id);

		if (this.isLoginChecked) {
			// console.log('mounted');
			this.shopEventRulesValidation();
		}
	}
};
